































































import Confirm from "@/shared/components/confirm.vue";
import DataTable, {
  PaginationData,
  TableHeader,
} from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { dateTime } from "@/shared/filters";
import GlobalMixin, { StateMenu } from "@/shared/mixins/globalMixin";
import { ServerPageOptions } from "@/shared/utils/datatable";
import dayjs from "dayjs";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import Filtro from "./Filtro.vue";
import Manter from "./Manter.vue";

@Component({
  components: {
    DataTable,
    Tooltip,
    Filtro,
    Confirm,
    Manter,
  },
  filters: { dateTime },
})
export default class Atendimentos extends mixins(GlobalMixin) {
  promise: Promise<PaginationData> | null = null;
  optins: ServerPageOptions | null = null;
  selectRow = true;
  msgFiltro = "Mostrar Filtros";

  headers: TableHeader[] = [
    { value: "idAtendimento", text: "Número" },
    { value: "dataAtendimento", text: "Data" },
    {
      value: "tipoAtendimento.descricao",
      text: "Tipo de Atendimento",
      withAliasValue: "tat.descricao",
    },
    { value: "descricao", text: "Descrição", withAliasValue: "ate.descricao" },
    { value: "consultor.nome", text: "Consultor", withAliasValue: "con.nome" },
    { value: "aberto", text: "Status" },
    { value: "quantidadeChamada", text: "Qtd. Chamadas" },
    { value: "ultimaDataChamada", text: "Última Chamada" },
    { value: "usuario.nome", text: "Responsável", withAliasValue: "usu.nome" },
    { value: "actions", text: "", sortable: false },
  ];

  mounted() {
    this.setMenuState(StateMenu.fechado);
  }

  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.novoFeriado();
  }

  selecionadoConsultor(item: any) {
    if (item) {
      const routeData = this.$router.resolve({
        name: "consultores",
        params: { idConsultor: item.consultor.idConsultor },
      });
      window.open(routeData.href, "_blank");
    }
  }

  chamada(item: any) {
    if (item) {
      this.$router.push({
        name: "detalhes",
        params: {
          idConsultor: item.consultor.idConsultor,
          idAtendimento: item.idAtendimento,
        },
      });
    }
  }

  itemRowBackground(item: any) {
    const dataAtual = dayjs();
    const dataAtendimento = dayjs(item.dataAtendimento, "YYYY-MM-DDTHH:mm:ss");
    const ultimaDataChamada = dayjs(
      item.ultimaDataChamada,
      "YYYY-MM-DDTHH:mm:ss"
    );
    const dataUmaSemana = dayjs().subtract(6, "day");
    const diff = dataAtendimento.diff(dataAtual);
    const diffSemana = ultimaDataChamada.diff(dataUmaSemana);

    if (item.aberto) {
      if (item.dataAtendimento && diff < 0) {
        return "style-1";
      }
      if (!item.dataAtendimento && item.ultimaDataChamada && diffSemana <= 0) {
        return "style-2";
      }
    }
  }
}
